var map = {
	"./ion-action-sheet-ios.entry.js": [
		719,
		29
	],
	"./ion-action-sheet-md.entry.js": [
		720,
		30
	],
	"./ion-alert-ios.entry.js": [
		721,
		31
	],
	"./ion-alert-md.entry.js": [
		722,
		32
	],
	"./ion-app_8-ios.entry.js": [
		723,
		11
	],
	"./ion-app_8-md.entry.js": [
		724,
		12
	],
	"./ion-avatar_3-ios.entry.js": [
		725,
		33
	],
	"./ion-avatar_3-md.entry.js": [
		726,
		34
	],
	"./ion-back-button-ios.entry.js": [
		727,
		35
	],
	"./ion-back-button-md.entry.js": [
		728,
		36
	],
	"./ion-backdrop-ios.entry.js": [
		729,
		79
	],
	"./ion-backdrop-md.entry.js": [
		730,
		80
	],
	"./ion-button_2-ios.entry.js": [
		731,
		37
	],
	"./ion-button_2-md.entry.js": [
		732,
		38
	],
	"./ion-card_5-ios.entry.js": [
		733,
		39
	],
	"./ion-card_5-md.entry.js": [
		734,
		40
	],
	"./ion-checkbox-ios.entry.js": [
		735,
		41
	],
	"./ion-checkbox-md.entry.js": [
		736,
		42
	],
	"./ion-chip-ios.entry.js": [
		737,
		43
	],
	"./ion-chip-md.entry.js": [
		738,
		44
	],
	"./ion-col_3.entry.js": [
		739,
		81
	],
	"./ion-datetime_3-ios.entry.js": [
		740,
		17
	],
	"./ion-datetime_3-md.entry.js": [
		741,
		18
	],
	"./ion-fab_3-ios.entry.js": [
		742,
		45
	],
	"./ion-fab_3-md.entry.js": [
		743,
		46
	],
	"./ion-img.entry.js": [
		744,
		82
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		745,
		83
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		746,
		84
	],
	"./ion-input-ios.entry.js": [
		747,
		47
	],
	"./ion-input-md.entry.js": [
		748,
		48
	],
	"./ion-item-option_3-ios.entry.js": [
		749,
		49
	],
	"./ion-item-option_3-md.entry.js": [
		750,
		50
	],
	"./ion-item_8-ios.entry.js": [
		751,
		51
	],
	"./ion-item_8-md.entry.js": [
		752,
		52
	],
	"./ion-loading-ios.entry.js": [
		753,
		53
	],
	"./ion-loading-md.entry.js": [
		754,
		54
	],
	"./ion-menu_3-ios.entry.js": [
		755,
		55
	],
	"./ion-menu_3-md.entry.js": [
		756,
		56
	],
	"./ion-modal-ios.entry.js": [
		757,
		13
	],
	"./ion-modal-md.entry.js": [
		758,
		14
	],
	"./ion-nav_2.entry.js": [
		759,
		25
	],
	"./ion-popover-ios.entry.js": [
		760,
		15
	],
	"./ion-popover-md.entry.js": [
		761,
		16
	],
	"./ion-progress-bar-ios.entry.js": [
		762,
		57
	],
	"./ion-progress-bar-md.entry.js": [
		763,
		58
	],
	"./ion-radio_2-ios.entry.js": [
		764,
		59
	],
	"./ion-radio_2-md.entry.js": [
		765,
		60
	],
	"./ion-range-ios.entry.js": [
		766,
		61
	],
	"./ion-range-md.entry.js": [
		767,
		62
	],
	"./ion-refresher_2-ios.entry.js": [
		768,
		19
	],
	"./ion-refresher_2-md.entry.js": [
		769,
		20
	],
	"./ion-reorder_2-ios.entry.js": [
		770,
		27
	],
	"./ion-reorder_2-md.entry.js": [
		771,
		28
	],
	"./ion-ripple-effect.entry.js": [
		772,
		85
	],
	"./ion-route_4.entry.js": [
		773,
		63
	],
	"./ion-searchbar-ios.entry.js": [
		774,
		64
	],
	"./ion-searchbar-md.entry.js": [
		775,
		65
	],
	"./ion-segment_2-ios.entry.js": [
		776,
		66
	],
	"./ion-segment_2-md.entry.js": [
		777,
		67
	],
	"./ion-select_3-ios.entry.js": [
		778,
		68
	],
	"./ion-select_3-md.entry.js": [
		779,
		69
	],
	"./ion-slide_2-ios.entry.js": [
		780,
		86
	],
	"./ion-slide_2-md.entry.js": [
		781,
		87
	],
	"./ion-spinner.entry.js": [
		782,
		23
	],
	"./ion-split-pane-ios.entry.js": [
		783,
		88
	],
	"./ion-split-pane-md.entry.js": [
		784,
		89
	],
	"./ion-tab-bar_2-ios.entry.js": [
		785,
		70
	],
	"./ion-tab-bar_2-md.entry.js": [
		786,
		71
	],
	"./ion-tab_2.entry.js": [
		787,
		26
	],
	"./ion-text.entry.js": [
		788,
		72
	],
	"./ion-textarea-ios.entry.js": [
		789,
		73
	],
	"./ion-textarea-md.entry.js": [
		790,
		74
	],
	"./ion-toast-ios.entry.js": [
		791,
		75
	],
	"./ion-toast-md.entry.js": [
		792,
		76
	],
	"./ion-toggle-ios.entry.js": [
		793,
		21
	],
	"./ion-toggle-md.entry.js": [
		794,
		22
	],
	"./ion-virtual-scroll.entry.js": [
		795,
		90
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 373;
module.exports = webpackAsyncContext;